import React from 'react';
import { Div, Span } from '@kizi/core-components';
import { IconV2 as Icon, withTooltip } from '@kizi/shared-components';

const TooltipIcon = withTooltip(Icon);
export const WidgetBadge = ({ label, tooltip }) => {
  return (
    <Div
      css={{
        display: 'flex',
        padding: 'var(--8pt-Grid-4px, 4px) var(--8pt-Grid-8px, 8px)',
        alignItems: 'center',
        gap: 'var(--8pt-Grid-4px, 4px)',
        borderRadius: 'var(--8pt-Grid-8px, 8px)',
        background: 'var(--Blue-100, #E8F2FF)',
        position: 'absolute',
        top: '-15px',
        right: '0px',
      }}
    >
      <Icon name={'piggy-bank'} size={20} fill="#105ECB" />
      <Span
        variant="footnoteImportant"
        css={{
          color: '#105ECB',
          fontWeight: '700',
          lineHeight: '24px',
        }}
      >
        {label}
      </Span>
      <TooltipIcon
        name="info"
        _popTo="bottom"
        size={16}
        css={{ fill: '#105ECB' }}
        _tooltip={tooltip}
        cursor="pointer"
        fill="#105ECB"
      />
    </Div>
  );
};
